// API client for the AI worker benchmark.
//
//   /public/benchmark      — no auth, scores-only projection (see evalController)
//   /admin/eval/runs/*     — super-admin token, full detail
//
// Fetch + auth plumbing is reused from templateStore so there is one place that
// knows how admin requests are shaped.
const { fetchJson, adminHeaders } = require('./templateStore');

// ── public ──────────────────────────────────────────────────────────────────

// Resolves { run, history }: run is the latest completed run (or null),
// history is [{ finishedAt, overallScore }] oldest → newest for the trend line.
function getPublicBenchmark() {
  return fetchJson('/public/benchmark').then(function (r) {
    return { run: (r && r.run) || null, history: (r && r.history) || [] };
  });
}

// ── admin ───────────────────────────────────────────────────────────────────

function adminListRuns() {
  return fetchJson('/admin/eval/runs', { headers: adminHeaders() })
    .then(function (r) { return (r && r.runs) || []; });
}

function adminGetRun(id) {
  return fetchJson('/admin/eval/runs/' + encodeURIComponent(id), { headers: adminHeaders() })
    .then(function (r) { return (r && r.run) || null; });
}

// options: { worker, tier, prompts: [], attacks: [], full }
// Returns immediately with { id, status } — the run continues server-side and
// the caller polls adminGetRun.
function adminStartRun(options) {
  return fetchJson('/admin/eval/runs', {
    method: 'POST',
    headers: adminHeaders(),
    body: options || {}
  });
}

module.exports = {
  getPublicBenchmark: getPublicBenchmark,
  adminListRuns: adminListRuns,
  adminGetRun: adminGetRun,
  adminStartRun: adminStartRun
};
